import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

function SelectOrganization(props) {
  const {
    orgId,
    setOrgId,
    organizations = [],
    portfolios = [],
    showAllOption = false,
    variant = 'standard',
    label = 'Organization',
    noneMessage = 'None Available',
  } = props;

  const handleChange = (event) => {
    setOrgId(event.target.value);
  };

  return (
    <FormControl fullWidth size='small' variant={variant}>
      <InputLabel id='organization-label'>{label}</InputLabel>
      <Select
        labelId='organization-label'
        disableUnderline={variant === 'filled'}
        id='organization'
        value={orgId}
        onChange={handleChange}
        MenuProps={{
          MenuListProps: {
            disablePadding: true,
            sx: {
              '& .MuiPaper-root': {
                minWidth: 'unset',
              },
            },
          },
          slotProps: {
            paper: {
              sx: {
                minWidth: 'unset !important',
              },
            },
          },
        }}
        sx={{
          backgroundColor: 'unset',
          '& .MuiSelect-select': {
            display: 'flex',
            alignItems: 'center',
          },
        }}
      >
        {showAllOption && (
          <MenuItem id={'empty-menu-item'} value=''>
            <ListItemText primary='Show All' />
          </MenuItem>
        )}
        {portfolios.length === 0 && organizations.length === 0 && (
          <MenuItem value='' disabled>
            {noneMessage}
          </MenuItem>
        )}
        {portfolios.length > 0 && <ListSubheader>Portfolios</ListSubheader>}
        {portfolios.length > 0 &&
          portfolios.map((portfolio) => (
            <MenuItem
              key={portfolio.org_id}
              id={`${portfolio.org_id}-menu-item`}
              value={portfolio.org_id}
            >
              <ListItemIcon>
                <FontAwesomeIcon icon={['fal', 'folder']} />
              </ListItemIcon>
              <ListItemText primary={portfolio.name} />
            </MenuItem>
          ))}
        {organizations.length > 0 && (
          <ListSubheader>Organizations</ListSubheader>
        )}
        {organizations.length > 0 &&
          organizations.map((organization) => (
            <MenuItem
              key={organization.org_id}
              id={`${organization.org_id}-menu-item`}
              value={organization.org_id}
            >
              <ListItemIcon>
                <FontAwesomeIcon icon={['fal', 'buildings']} />
              </ListItemIcon>
              <ListItemText primary={organization.name} />
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
}

SelectOrganization.defaultProps = {
  organizations: [],
  portfolios: [],
};

SelectOrganization.propTypes = {
  orgId: PropTypes.string,
  setOrgId: PropTypes.func.isRequired,
  organizations: PropTypes.array,
  portfolios: PropTypes.array,
  label: PropTypes.string,
  noneMessage: PropTypes.string,
};

export default SelectOrganization;
